
class InstructorNavController {
    constructor($scope, PoliciesModel){
    }
}
InstructorNavController.$inject = ['$scope', 'PoliciesModel'];
export default InstructorNavController;